import Api from "@nextories/vue-tasks/src/utils/Api";

export default class AppApi extends Api {
  /**
   * Retrieve the project of the current user from the backend
   * @returns {Promise<Object>} resolve with the project for the current user
   * or reject with the backend error message
   */
  getSearchProjects(query: string): Promise<any> {
     
    return this._nxtGetData(`/coord/search-demenagement${query ? `?${query}` : ''}`);
  }

  getCountTasks(request: {}): Promise<any> {
    request.count_tasks = true;
     
    return this._nxtPostData('/coord/list-tasks', request);
  }

  getProjects(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/list-dgts', request);
  }

  getProject(id: string) {
     
    return this._nxtGetData(`/coord/tasks/${id}`);
  }

  updateProject(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/update-project', request);
  }

  getListTasksType() {
     
    return this._nxtGetData('/coord/list-tasks-type');
  }

  getTasks(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/list-tasks', request);
  }

  postUpdateMultitasks(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/update-multitasks', request);
  }

  postTask(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/create-task', request);
  }

  updateTask(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/create-task', request);
  }

  deleteTask(id: string) {
     
    return this._nxtPostData(`/coord/delete-task/${id}`);
  }

  getDisputes(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/list-disputes', request);
  }

  getDiary(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/list-tasks-calendar', request);
  }

  getFurnitureStorage(request: {}): Promise<any> {
     
    return this._nxtPostData('/coord/list-gm', request);
  }
}
